import styled, { keyframes } from "styled-components";

const glow = keyframes`
  from {
    text-shadow: 0 0 5x #c22323, 0 0 7px #c22323, 0 0 9px #c22323;
  }
  to {
    text-shadow: 0 0 7px #c22323, 0 0 9px #c22323, 0 0 11px #c22323;
  }
`;

export const HomeContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const Title = styled.div`
  font-family: "Cinzel", serif;
  font-size: 5em;
  color: #d0021b;
  animation: ${glow} 1.5s ease-in-out infinite alternate;
  text-align: center;

  @media only screen and (max-width: 500px) {
    font-size: 3em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 2.25em;
  }
`;

export const Logo = styled.img`
  color: #d0021b;
  height: 100px;
`;

export const SmallTitle = styled.div`
  font-family: "Cinzel", serif;
  font-size: 4em;
  color: #d0021b;
  animation: ${glow} 1.5s ease-in-out infinite alternate;
  text-align: center;

  @media only screen and (max-width: 500px) {
    font-size: 2.5em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 1.5em;
  }
`;

export const Form = styled.input`
  transition-duration: 0.2s;
  font-size: 1.25em;
  font-weight: 700;
  background-color: #636363;
  border: none;
  text-align: center;
  padding: 0.5em;
  margin: 1.5em;
  border-radius: 16px;
  height: 1.5em;
  width: 15em;
  &::placeholder {
    color: darkgray;
  }
  &:focus {
    border: 2px;
    border-color: white;
    background-color: lightgray;
    color: black;
    outline: none;
  }

  @media only screen and (max-width: 500px) {
    font-size: 1.125em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 1em;
  }
`;

export const Button = styled.button`
  outline: none;
  cursor: pointer;
  transition-duration: 0.2s;
  border: none;
  font-weight: 700;
  background-color: #b80016;
  color: white;
  margin: 0.5em;
  width: 10em;
  height: 2.5em;
  border-radius: 16px;
  &:disabled {
    cursor: default;
    background-color: #969696;
    color: #c7c7c7;
  }
  &:hover:enabled {
    background-color: #ff001f;
    box-shadow: 0 2px 3px #999;
  }
  &:active:enabled {
    box-shadow: 0 0px 2px #666;
    background-color: #ff001f;
    transform: translateY(1px);
  }

  @media only screen and (max-width: 500px) {
    width: 8.5em;
    height: 2.25em;
    font-size: 1em;
  }

  @media only screen and (max-width: 375px) {
    width: 8.25em;
    height: 2.125em;
    font-size: 0.9em;
  }
`;

export const Text = styled.h2`
  font-size: 1.25em;
  font-weight: 700;
  text-align: center;
  color: white;

  @media only screen and (max-width: 500px) {
    font-size: 1.125em;
  }

  @media only screen and (max-width: 375px) {
    font-size: 1em;
  }
`;
